// "Items in this package" (Stephanie 2026-11-04: "how does the system know if
// only one item on a PO has shipped" → yes). Shown when a PO has two or more
// items; all ticked = the whole PO. The client's "has shipped" email names only
// the ticked items.
export interface PackageItem {
  id: string;
  name: string;
}

/** PURE — what to send: undefined when everything is ticked (the whole PO). */
export function packageItemIds(items: readonly PackageItem[], picked: ReadonlySet<string>): string[] | undefined {
  const ids = items.filter((i) => picked.has(i.id)).map((i) => i.id);
  return ids.length === items.length ? undefined : ids;
}

export function PackageItemsPicker(props: {
  items: readonly PackageItem[];
  picked: ReadonlySet<string>;
  onChange: (next: Set<string>) => void;
  compact?: boolean;
}) {
  const { items, picked, onChange, compact } = props;
  if (items.length < 2) return null;
  return (
    <fieldset className={compact ? "flex flex-col gap-1" : "flex flex-col gap-1.5"}>
      <legend className="mb-1 text-xs font-medium text-muted">Items in this package</legend>
      {items.map((i) => (
        <label key={i.id} className={compact ? "flex items-center gap-2 text-xs text-ink" : "flex items-center gap-2 text-sm text-ink"}>
          <input
            type="checkbox"
            checked={picked.has(i.id)}
            onChange={(e) => {
              const next = new Set(picked);
              if (e.target.checked) next.add(i.id);
              else next.delete(i.id);
              onChange(next);
            }}
            className="h-4 w-4 rounded border-rule"
          />
          <span className="min-w-0 truncate">{i.name}</span>
        </label>
      ))}
      {picked.size === 0 && <p role="alert" className="text-xs text-risk">Tick at least one item.</p>}
    </fieldset>
  );
}
